import { useGetPermissionsEachPage } from "@lhd/hooks";
import { ROUTES } from "@lhd/constants";
import { IPermissionItem } from "@lhd/types";

const FALLBACK_PERMISSION: IPermissionItem = {
  create: true,
  edit: true,
  delete: true,
  view: true,
  all: true,
};

const useEdit = () => {
  const permissionsEachPage = useGetPermissionsEachPage();

  return {
    permissionItem:
      (permissionsEachPage[ROUTES.FINANCIAL_REPORTS] as IPermissionItem) ||
      FALLBACK_PERMISSION,
  };
};

export type Props = ReturnType<typeof useEdit>;

export default useEdit;
